var map = {
	"./BicchieriW255.png": 10045,
	"./CavatappOneW255.png": 36993,
	"./CavatappiW255.png": 15084,
	"./DecanterW255.png": 60755,
	"./OssigenatoreTwoW255.png": 27678,
	"./PortabottiglieOneW255.png": 64850,
	"./PortabottiglieW255.png": 8326,
	"./SetDegustazioneTwoW255.png": 45581,
	"./SetDegustazioneW255.png": 76209,
	"./TappoOneW255.png": 33401,
	"./TappoTwoW255.png": 74147,
	"./TermometriW255.png": 58655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69479;